/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Better_Studio_Nav_ResourcesInputs */

const en_better_studio_nav_resources = /** @type {(inputs: Better_Studio_Nav_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resources`)
};

/**
* | output |
* | --- |
* | "Resources" |
*
* @param {Better_Studio_Nav_ResourcesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const better_studio_nav_resources = /** @type {((inputs?: Better_Studio_Nav_ResourcesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Better_Studio_Nav_ResourcesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_better_studio_nav_resources(inputs)
});